import './error.css'

/* eslint-disable no-unused-vars */
export default function Error(/* props: Props */) {
  return (
    <div>
      ERROR
    </div>
  )
}
